export default __webpack_public_path__ + "static/media/Matt.a774110f.png";